<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
    >
    </v-col>
    <v-col
      cols="12"
      :sm="isDesktop && !isSimulation ? 6 : 12"
      v-for="(item, index) of recursos"
      :key="index"
    >
      <resource :data="item" />
    </v-col>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import Resource from '@/components/Resource'
  export default {
    components: {
      Resource,
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data () {
      return {
        recursos: [],
        hidden: false,
      }
    },
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'ColorContent', 'BGColorSecundary', 'ColorSecundary']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
    },
    watch: {
      'data.InfotenFilters' (v) {
        if (v) this.getData(v)
      }
    },
    mounted () {
      if(this.data.InfotenFilters) this.getData(this.data.InfotenFilters)
    },
    methods: {
      handleExpand (item) {
        item.expand = !item.expand
      },
      prepareDescription(v) {
        return {
          es: v.DescripcionEspanol.length > 0 ? v.DescripcionEspanol : null,
          en: v.DescripcionIngles.length > 0 ? v.DescripcionIngles : null,
          du: v.DescripcionAleman.length > 0 ? v.DescripcionAleman : null,
          fr: v.DescripcionFrances.length > 0 ? v.DescripcionFrances : null,
          it: v.DescripcionItaliano.length > 0 ? v.DescripcionItaliano : null,
        }
      },
      prepareInfo (v) {
        return {
          es: v.ComoLlegarEspanol.length > 0 ? v.ComoLlegarEspanol : null,
          en: v.ComoLlegarIngles.length > 0 ? v.ComoLlegarIngles : null,
          du: v.ComoLlegarAleman.length > 0 ? v.ComoLlegarAleman : null,
          fr: v.ComoLlegarFrances.length > 0 ? v.ComoLlegarFrances : null,
          it: v.ComoLlegarItaliano.length > 0 ? v.ComoLlegarItaliano : null,
        }
      },
      getData (v) {
        const body = typeof v === 'object' ? v : JSON.parse(v)
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.post(`${url}public/infoten/recursos`, body)
        //axios.post('http://dtouch.local:3400/public/infoten/recursos', body)
          .then(response => {
            this.recursos = response.data.map(item => {
              const description = this.prepareDescription(item)

              return {
                BrochureImage: item.Imagen ? item.Imagen.split(',').shift() : null,
                BrochureTitle: {
                  es: item.Nombre,
                },
                BrochureSubtitle: {
                  es: item.ClasificacionTipo,
                },
                BrochureDescription: description,
                BrochureWithDescription: true,
                BrochureWithFacts: item.Horarios.length > 0 || item.Precio.length > 0 ? true : false,
                BrochureHours: {es: item.Horarios },
                BrochurePrice: {es: item.Precio },
                BrochureWithContact: true,
                BrochurePhone: item.Telefono,
                BrochureEmail: item.Email,
                BrochureWeb: item.Web,
                BrochureWithLocation: true,
                BrochureAddress: item.Direccion,
                BrochurePostalCode: item.CodigoPostal,
                BrochureMunicipaly: item.Municipio,
                BrochureInfo: this.prepareInfo(item)
              }
            })
          })
      }
    }
  }
</script>
<style scope>
.brochure .v-toolbar__content {
  height: 40px!important;
}
  .brochure p {
    line-height: 1.2;
    margin: 0px !important;
    width: 100%;
  }
  .brochure-description {
    padding: 10px 20px;
  }

  .brochure-facts {
    padding: 10px 20px;
  }

  .brochure-contact {
    width: 100%;
    margin: 5px 10px !important;
    border-radius: 8px !important;
    padding-bottom: 10px;
  }

  .brochure-contact-item {
    margin: 0px 20px;
    padding: 8px 0px;
  }

  .brochure-contact-item-first {
    margin: 0px 20px;
    padding: 8px 0 8px 0;
  }

  .brochure-services {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.07) !important;
    margin: 15px !important;
    padding: 5px 10px 10px 10px;
    border-radius: 8px !important;
  }
  /*.brochure-services .title {
    line-height: 1;
    margin: 0px;
  }*/
</style>

